import { AccountPortalProps } from '@account/account-portal'
import { AccountPortal as AccountPortalMf } from '@account/account-portal-mf'
import { Context } from '@crystal/config'
import { useMfProps } from '@crystal/core'
import { FC } from 'react'

interface Props extends AccountPortalProps {
  context: Context
}

export const AccountPortal: FC<Props> = props => {
  const { mfServer } = useMfProps()
  return <AccountPortalMf mfId={'.'} mfServer={mfServer} {...props} />
}
